import {createContext} from "react";

const BoardContext = createContext(null)

export default BoardContext